import React from "react";
import {withRouter} from "react-router";
import Framework from "@beardeddevops/react.framework";
import Types from 'constants/Types';
import TextField from "@material-ui/core/TextField/index";
import {
	buildDenomPayload,
	computeCounted,
	DENOMINATIONS,
	emptyDenomCounts,
	parseDenominations,
} from "utils/registerDenominations";

class AccountRegisterAuditing extends Framework.Components.Object {

	constructor(props) {
		super(props, Types.Accounts_Customizations._name);
		this.noDelete = false;
		this.state.defaultDenomCounts = emptyDenomCounts();

		const frameworkModelSubmit = this.model.submit;
		this.model.submit = (component, request, ...args) => {
			if (component === this) {
				const nextState = {...component.state};
				if (this.isRetainedFloatEnabled()) {
					nextState.retained_float = this.normalizeRetainedFloatForSave(component.state.retained_float);
				}
				if (!this.isDefaultDenomSpreadEnabled()) {
					nextState.register_default_denominations = null;
				} else if (
					nextState.register_default_denominations === ''
					|| nextState.register_default_denominations == null
				) {
					nextState.register_default_denominations = '{}';
				}
				return frameworkModelSubmit({
					...component,
					state: nextState,
					setState: component.setState ? component.setState.bind(component) : undefined,
				}, request, ...args);
			}
			return frameworkModelSubmit(component, request, ...args);
		};
	}

	loadSelfAfter = (data) => {
		this.setState({
			defaultDenomCounts: data.register_default_denominations != null
				? parseDenominations(data.register_default_denominations)
				: emptyDenomCounts(),
		});
	}

	afterSubmit = () => {
		window.location.reload();
	}

	confirmDefaultDenomFloatMismatch = () => {
		if (!this.isRetainedFloatEnabled() || !this.isDefaultDenomSpreadEnabled()) {
			return true;
		}
		const floatAmount = parseFloat(this.normalizeRetainedFloatForSave(this.state.retained_float));
		const denomTotal = computeCounted(this.state.defaultDenomCounts || emptyDenomCounts());
		if (Number.isNaN(floatAmount) || Math.abs(floatAmount - denomTotal) < 0.005) {
			return true;
		}
		return window.confirm(
			`Default denomination spread total ($${denomTotal.toFixed(2)}) does not match `
			+ `Retained Register Float ($${floatAmount.toFixed(2)}). Save anyway?`
		);
	};

	handleSubmit = async (ev) => {
		if (!this.confirmDefaultDenomFloatMismatch()) {
			this.setState({loading: false});
			return;
		}
		await super.handleSubmit(ev);
	};

	isRetainedFloatEnabled = () => this.state.retained_float != null;

	setRetainedFloatEnabled = (enabled) => {
		const property = this.model.properties.retained_float;
		if (enabled) {
			const current = this.state.retained_float;
			const next = current != null ? current : '';
			this.handleTextFieldPropertyUpdate('retained_float', next, property);
		} else {
			this.handleTextFieldPropertyUpdate('retained_float', null, property);
		}
	};

	normalizeRetainedFloatForSave = (value) => {
		if (value == null || value === '') {
			return '0.00';
		}
		const parsed = parseFloat(value);
		if (Number.isNaN(parsed) || parsed < 0) {
			return '0.00';
		}
		return parsed.toFixed(2);
	};

	handleRetainedFloatUpdate = (name, value, property) => {
		if (value == null) {
			return;
		}
		if (value === '') {
			this.handleTextFieldPropertyUpdate(name, value, property);
			return;
		}
		if (!/^\d*\.?\d{0,2}$/.test(value)) {
			return;
		}
		const parsed = parseFloat(value);
		if (!Number.isNaN(parsed) && parsed < 0) {
			value = '0';
		}
		this.handleTextFieldPropertyUpdate(name, value, property);
	};

	handleRetainedFloatBlur = () => {
		if (!this.isRetainedFloatEnabled()) {
			return;
		}
		const property = this.model.properties.retained_float;
		const next = this.normalizeRetainedFloatForSave(this.state.retained_float);
		if (this.state.retained_float !== next) {
			this.handleTextFieldPropertyUpdate('retained_float', next, property);
		}
	};

	isDefaultDenomSpreadEnabled = () => this.state.register_default_denominations != null;

	setDefaultDenomSpreadEnabled = (enabled) => {
		const property = this.model.properties.register_default_denominations;
		if (enabled) {
			const current = this.state.register_default_denominations;
			const next = current != null ? current : '{}';
			this.handleTextFieldPropertyUpdate('register_default_denominations', next, property);
		} else {
			this.handleTextFieldPropertyUpdate('register_default_denominations', null, property);
		}
	};

	handleDefaultDenomChange = (key) => (event) => {
		if (!this.isDefaultDenomSpreadEnabled()) {
			return;
		}
		const raw = event.currentTarget.value;
		const counts = {...(this.state.defaultDenomCounts || emptyDenomCounts()), [key]: raw === '' ? '0' : raw};
		const serialized = JSON.stringify(buildDenomPayload(counts));
		this.setState({defaultDenomCounts: counts});
		this.handleTextFieldPropertyUpdate(
			'register_default_denominations',
			serialized,
			this.model.properties.register_default_denominations
		);
	};

	renderDefaultDenominationSpread = () => {
		const counts = this.state.defaultDenomCounts || emptyDenomCounts();
		const rows = [];
		for (let i = 0; i < DENOMINATIONS.length; i += 6) {
			rows.push(DENOMINATIONS.slice(i, i + 6));
		}
		return (
			<div className="form-group">
				{rows.map((denoms, rowIndex) => (
					<div className={"row"} key={rowIndex}>
						{denoms.map(d => (
							<div className={"col-2"} key={d.key} style={{marginBottom: 10}}>
								<TextField
									type={"number"}
									label={d.label}
									margin={"dense"}
									variant="outlined"
									value={counts[d.key] ?? '0'}
									onChange={this.handleDefaultDenomChange(d.key)}
									inputProps={{min: 0}}
									fullWidth={true}
								/>
							</div>
						))}
					</div>
				))}
			</div>
		);
	};

	form = () => {
		const {properties} = this.model;
		const object = this.state;

		return (
			<div className={'form-group'}>
				<div className={'row'}>
					<div className={'col-6'}>
						<h4 className={'section-title'}>Register Preferences</h4>
						<div className={'form-group'}>
							<b>Retained Register Float</b>
							<Framework.Elements.ButtonSwitch
								value={this.isRetainedFloatEnabled()}
								error={object.retained_float_error}
								property={properties.retained_float}
								update={(name, value) => this.setRetainedFloatEnabled(!!value)}
								labelTrue={"Enabled"}
								labelFalse={"Disabled"}
								project={'pos'}
							/>
							<small className={'text-muted d-block'}>When enabled, Start/End of Day can target a fixed cash amount left in the drawer overnight (including $0.00).</small>
						</div>
						{this.isRetainedFloatEnabled() &&
							<div className="form-group">
								<Framework.Elements.DollarAmount
									name={"retained_float"}
									label={"Retained Register Float Amount"}
									property={properties.retained_float}
									value={object.retained_float ?? ""}
									error={object.retained_float_error}
									update={this.handleRetainedFloatUpdate}
									handleBlur={this.handleRetainedFloatBlur}
									margin={"dense"}
								/>
								<small className={'text-muted'}>Used at End of Day to compute the cash deposit and to reconcile Start/End of Day amount-field audits.</small>
							</div>}
						<div className={'form-group'}>
							<b>Require Note for Cash Variance</b>
							<Framework.Elements.ButtonSwitch
								value={object.register_require_variance_note ?? false}
								error={object.register_require_variance_note_error}
								property={properties.register_require_variance_note}
								update={this.handleTextFieldPropertyUpdate}
								labelTrue={"Required"}
								labelFalse={"Optional"}
								project={'pos'}
							/>
							<small className={'text-muted d-block'}>When enabled, a note is required whenever a count or Start/End of Day has a non-zero variance.</small>
						</div>
					</div>
					<div className={'col-6'}>
						<h4 className={'section-title'}>Denomination Preferences</h4>
						<div className={'form-group'}>
							<b>Use Denominations for Start/End of Day</b>
							<Framework.Elements.ButtonSwitch
								value={object.register_audit_denominations ?? false}
								error={object.register_audit_denominations_error}
								property={properties.register_audit_denominations}
								update={this.handleTextFieldPropertyUpdate}
								labelTrue={"Denominations"}
								labelFalse={"Amount Field"}
								project={'pos'}
							/>
							<small className={'text-muted d-block'}>When enabled, Start/End of Day uses bill/coin counts. When disabled, enter a single cash amount instead.</small>
						</div>
						{object.register_audit_denominations ?
							<>
								<div className={'form-group'}>
									<b>Default Denomination Spread</b>
									<Framework.Elements.ButtonSwitch
										value={this.isDefaultDenomSpreadEnabled()}
										error={object.register_default_denominations_error}
										property={properties.register_default_denominations}
										update={(name, value) => this.setDefaultDenomSpreadEnabled(!!value)}
										labelTrue={"Enabled"}
										labelFalse={"Disabled"}
										project={'pos'}
									/>
									<small className={'text-muted d-block'}>When enabled, bill/coin counts can be pre-filled on Start of Day after a count (including all zeros).</small>
								</div>
								{this.isDefaultDenomSpreadEnabled() ?
									this.renderDefaultDenominationSpread()
									: null}
							</>
							: null}
					</div>
				</div>
			</div>
		);
	}
}

export default Framework.Components.withRootState(withRouter(AccountRegisterAuditing));
